import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface GoodsBannerPick {
	goodsCd: string;
	bnrMstNo: string;
	webBannerLink: string;
	link: string;
	mlink: string;
}

/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/
const key = `useGoodsBannerPick`;
const getPath = (): string | null => `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/banner/pick`;

/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/
const useGoodsBannerPick = (goodsCd: string, options?: Partial<UseQueryOptions<Response<GoodsBannerPick>, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), params: {goodsCd}}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useGoodsBannerPick;
export {getPath, key};
export type {GoodsBannerPick};
